import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { TemplateForm } from "@/features/quotation-templates/TemplateForm";
import { useQuotationTemplate } from "@/features/quotation-templates/api";

export const Route = createFileRoute("/_authenticated/quotation-templates/$templateId")({
  component: EditTemplate,
});

function EditTemplate() {
  const { templateId } = Route.useParams();
  const { data, isLoading } = useQuotationTemplate(templateId);
  if (isLoading) return <div className="grid place-items-center p-10"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  if (!data) return <div className="p-6 text-sm text-muted-foreground">Template not found.</div>;
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Edit Template: {data.name}</h1>
      <TemplateForm initial={data} />
    </div>
  );
}
